import { useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { selectSong } from 'services/store/newSongs/selectors';
import { analytics, events } from 'services/analytics';
import { AnalyticsEventLocation } from 'services/analytics/entities';
import songsApi from 'services/api/songs/songsApi';
import useMessageSnackbar from '../useMessageSnackbar';

type PropsType = {
  songId: string;
  location: AnalyticsEventLocation;
};

const useRemoveFromLibrary = ({ songId, location }: PropsType) => {
  const { t } = useTranslation();

  const [removeFromLibrary, { isLoading, isError }] =
    songsApi.useRemoveFromLibraryMutation();

  const song = useSelector(selectSong(songId));

  const { displayErrorSnackbar } = useMessageSnackbar();

  const removeSongFromLibrary = useCallback(() => {
    if (!song) {
      return;
    }

    const { id, songType, isInLibrary } = song;
    if (isInLibrary) {
      removeFromLibrary({ songId: id });
      analytics.track(events.removedLibrary(id, songType, location));
    }
  }, [song, location, removeFromLibrary]);

  useEffect(() => {
    if (isError) {
      displayErrorSnackbar(t('messages:error:unknown'));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [t, isError]);

  return {
    isLoading,
    removeSongFromLibrary,
  };
};

export default useRemoveFromLibrary;
